import Feature from "ol/Feature";
import { GeoJSON } from "ol/format";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { selectionStyle } from "../styles/selectionStyle";
import { Style, Fill } from "ol/style";
export default class SelectionLayer extends VectorLayer {
    constructor() {
        super();
        this.setZIndex(10);
        this.setSource(new VectorSource());
        this.set("name", "selectionLayer");
    }
    addFeatures(features) {
        this.getSource().addFeatures(features);
    }
    setFeaturesFromGeometry(geometry) {
        const features = geometry.map((g) => new Feature({
            geometry: g,
        }));
        this.getSource().clear();
        this.addFeatures(features);
    }
    setVisibleFeatures(geometry) {
        this.getSource()
            .getFeatures()
            .map((f) => {
            if (geometry.includes(f.getGeometry())) {
                f.setStyle(selectionStyle);
            }
            else {
                f.setStyle(new Style({
                    fill: new Fill({
                        color: "rgba(0,0,0,0)",
                    }),
                }));
            }
        });
    }
    static convertGeoJsonToGeometries(geojson) {
        const features = new GeoJSON({
            featureProjection: "EPSG:3857",
        }).readFeatures(geojson);
        return features.map((feature) => feature.getGeometry());
    }
    addFeatureFromGeojson(geojson) {
        const geometry = SelectionLayer.convertGeoJsonToGeometries(geojson);
        const features = geometry.map((g) => new Feature({
            geometry: g,
        }));
        this.addFeatures(features);
        return features;
    }
    getFeatureFromGeojson(geojson) {
        const geometry = SelectionLayer.convertGeoJsonToGeometries(geojson);
        const features = geometry.map((g) => new Feature({
            geometry: g,
        }));
        return features;
    }
}
